import { type IAvailableIcons } from '@/CommonComponents/Icon'
import { Icon } from '@/CommonComponents'
import { Button as MUIIconButton } from '@mui/material'
import type { SxProps } from '@mui/material'
import type { IColor } from './types'
interface IIconButtonPropsBase {
  icon: IAvailableIcons
  color?: IColor
  sx?: SxProps
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  label?: string
  variant?: 'text' | 'outlined' | 'contained'
  size?: 'small' | 'medium' | 'large'
  onUpload?: (files: FileList | null) => void
  disabled?: boolean
}

type IIconButtonProps =
  | (IIconButtonPropsBase & { download?: false; href?: never })
  | (IIconButtonPropsBase & { download: true; href: string })

const onDownload = (href: string) => {
  return () => {
    const link = document.createElement('a')
    link.download = href
    link.href = href
    link.click()
  }
}

export default function IconButton({
  icon,
  sx,
  onClick,
  label,
  variant,
  color,
  download,
  href,
  size,
  onUpload,
  disabled,
}: IIconButtonProps) {
  const clickHandler = download ? onDownload(href) : onClick
  return (
    <MUIIconButton
      component="label"
      sx={{ minWidth: 0, p: 0, m: 0, ...sx }}
      onClick={clickHandler}
      disabled={disabled}
      color="inherit"
      size={size}
      variant={variant}
    >
      {label}
      <Icon icon={icon} color={color} />
      {onUpload && (
        <input
          type="file"
          style={{ display: 'none' }}
          onChange={(event) => {
            onUpload(event.target.files)
          }}
        />
      )}
    </MUIIconButton>
  )
}
